export const roles = {
  title: 'Role',
  subtitle:
    'Zarządzaj rolami użytkowników i określaj, do jakich zasobów systemu mają dostęp',
  searchPlaceholder: 'Wyszukaj rolę...',
  allRoles: 'Wszystkie role',
  rolesCount: '{count} role',
  add: 'Dodaj rolę',
  deleteRole: 'Usuń rolę',
  deletedQuestion: 'Czy na pewno chcesz usunąć rolę: {roleName}',
  deleteSuccess: 'Usunięto rolę',
  createdRole: 'Utworzono rolę',
  savedChanges: 'Zapisano zmiany',
  saveChanges: 'Zapisz zmiany',
  selectRole: 'Wybierz rolę, aby zobaczyć szczegóły',
  details: 'Szczegóły roli',
  roleId: 'ID roli',
  nameLabel: 'Nazwa roli',
  descriptionLabel: 'Opis roli',
  descriptionPlaceholder: 'Dodaj opis roli (opcjonalnie)',
  baseRoleNotice:
    'Ta rola została utworzona przez system. Nie można edytować jej nazwy ani jej usunąć. Można edytować tylko uprawnienia.',
  permissionsTitle: 'Uprawnienia',
  permissionsSubtitle:
    'Określ, co użytkownicy z tą rolą mogą przeglądać i zmieniać',
  noRolesFound: 'Nie znaleziono ról',
  titles: {
    flowEngine: 'Uprawnienia Szablonu Konfiguracji',
    users: 'Uprawnienia Użytkownika',
    roles: 'Uprawnienia Administratora',
  },
  create: {
    title: 'Nowa rola',
    description: 'Utwórz nową rolę i nadaj jej podstawowe informacje.',
    submit: 'Utwórz rolę',
    namePlaceholder: 'np. moderator',
    descriptionLabel: 'Opis',
    descriptionPlaceholder: 'Krótki opis roli (opcjonalnie)',
    permissionsNotice:
      'Uprawnienia ustawisz w kolejnym kroku, zaraz po utworzeniu roli.',
  },
}
